import { useNav } from "@pomle/react-router-paths";
import { paths } from "render/routes/paths";
import { InformationLayout } from "render/ui/layout/InformationLayout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent/PageFrameContent";
import { Button, Typography } from "@cur8/maneki";

export function VisitNotFoundView() {
  const nav = {
    start: useNav(paths.root),
  };

  return (
    <PageFrameContent>
      <InformationLayout
        align="start"
        content={
          <>
            <Typography variant="display-s">Appointment not found</Typography>
            <Typography variant="body-m" color="subtle">
              We couldn't find the member's appointment today. Please check the
              schedule and try again.
            </Typography>
          </>
        }
        buttons={
          <Button
            variant="secondary"
            onPress={() => nav.start.go({})}
            fillContainer
          >
            Back
          </Button>
        }
      />
    </PageFrameContent>
  );
}
